import styled, { css } from 'styled-components';
import LoginSerivce from '../../../service/login/login';

const socials = [
  {
    label: '카카오',
    value: 'kakao',
    storage: 'K',
  },
  {
    label: '네이버',
    value: 'naver',
    storage: 'N',
  },
  {
    label: 'Google',
    value: 'google',
    storage: 'G',
  },
];

function SocialLogin() {
  const SocialLoginApi = (type: string) => {
    LoginSerivce.socialLogin(type, window.location.origin);
  };

  return (
    <Container>
      {socials.map((item) => (
        <Button
          key={item.value}
          $type={item.value}
          onClick={() => {
            SocialLoginApi(item.value);
            localStorage.setItem('socialLoginType', item.storage);
          }}
        >
          <SocialButtonIcon
            src={`/assets/images/logo/${item.value}-logo.svg`}
            alt={item.value}
          />
          {item.label}로 시작하기
        </Button>
      ))}
    </Container>
  );
}

export default SocialLogin;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

const Button = styled.div<{ $type: string }>`
  position: relative;
  display: flex;
  padding: 14px 16px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  cursor: pointer;
  border-radius: 8px;

  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;

  ${({ $type }) => {
    switch ($type) {
      case 'kakao':
        return css`
          background-color: #fde40b;
          color: #27272a;
        `;
      case 'naver':
        return css`
          background-color: #00c300;
          color: #fff;
        `;
      default:
        return css`
          background-color: #fff;
          color: #222;
          border: 1px solid #e1e2e4;
        `;
    }
  }}
`;

const SocialButtonIcon = styled.img`
  width: 20px;
  height: 20px;

  position: absolute;
  left: 16px;
  bottom: 15px;
`;
